export function isStringEmpty(string): Boolean {
    return !string || string.trim() === ''
}

export function isString(object): Boolean {
    return typeof object === 'string'
}

export function isSubString(stringA, stringB): Boolean {
    if (isStringEmpty(stringA) || isStringEmpty(stringB)) {
        return false
    }
    return formatString(stringB).includes(formatString(stringA))
}

export function isEqual(stringA, stringB): Boolean {
    if (isStringEmpty(stringA) || isStringEmpty(stringB)) {
        return false
    }
    return formatString(stringB) === formatString(stringA)
}

function formatString(string): str {
    return string.replace( /[\r\n]+/gm, ' ').replace(/  +/g, ' ').trim().toLowerCase()
}

export function generateRandomString(): String {
    return Math.random().toString(36).substr(2, 9)
}

export function generateHTMlId(str: String): String {
    if (!str || typeof str !== 'string') {
        return ''
    }
    return str.toLowerCase().replace(/[^a-zA-Z0-9]+/g, '-')
}

export function fileExtension(str: String): String {
    if (!str || typeof str !== 'string') {
        return ''
    }
    const parts = str.split('.')
    if (parts.length === 0) {
        return ''
    }
    return parts[parts.length-1]
}

const RegexUUID = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-5][0-9a-f]{3}-[089ab][0-9a-f]{3}-[0-9a-f]{12}$/i
export function isUUID(str: String): Boolean {
    return RegexUUID.test(str)
}

export function isValueEmpty(value): Boolean {
    return value === null || value === undefined || (typeof value === 'string' && value.trim() === '')
}

export function isNumber(value): Boolean {
    return isValueEmpty(value) || /^\d+$/.test(value)
}

export function isDecimalNumber(value): Boolean {
    return isValueEmpty(value) || /^\d+\.?\d*$/.test(value)
}

export function equalIgnoreCase (strA: String, strB: String): Boolean {
    if (typeof strA !== 'string' || typeof strB !== 'string') {
        return false
    } else if (!strA || !strB) {
        return false
    } else if (strA.toLocaleLowerCase() !== strB.toLocaleLowerCase()) {
        return false
    } else {
        return true
    }
}

export const areStringsEqual = (stringA: String, stringB: String): Boolean => {
    if (!!stringA && !!stringB) {
        return stringA.trim().toLowerCase() === stringB.trim().toLowerCase()
    }
    return false
}